import fetch from '../utils/fetch'
export function getFeedBack (query) {
  return fetch({
    url: '/distributor/getList',
    method: 'get',
    params: query
  })
}




// WEBPACK FOOTER //
// ./src/api/distributorfeedback.js